import { library } from '@fortawesome/fontawesome-svg-core'
import * as i from '@fortawesome/free-solid-svg-icons'

library.add(
  i.faAngleDoubleLeft,
  i.faAngleDoubleRight,
  i.faAt,
  i.faBoxes, 
  i.faBuilding,
  i.faCartArrowDown, 
  i.faCheck,
  i.faChevronLeft, 
  i.faChevronRight,
  i.faCommentDollar,
  i.faCommentsDollar,
  i.faDownload,
  i.faEnvelopeSquare,
  i.faFileAlt,
  i.faFilePdf,
  i.faFileImage,
  i.faFileInvoice, 
  i.faHome, 
  i.faInfoCircle,
  i.faKey,
  i.faList,
  i.faMoneyBillAlt,
  i.faPhoneSquare,
  i.faPrint,
  i.faPlus,
  i.faQrcode,
  i.faTable,
  i.faTimes,
  i.faTrash,
  i.faUser,
  i.faUpload,
  i.faWallet,
  i.faClipboardList,
  i.faWarehouse,
  i.faCogs,
  i.faWrench,
  i.faBullhorn,
  i.faUsers,
  i.faCalendarAlt,
  i.faStop,
  i.faPencilRuler,
  i.faProjectDiagram,
  i.faMap,
  i.faHotel,
  i.faBalanceScale,
  i.faUsersCog,
  i.faIndustry,
  i.faMobile,
  i.faMobileAlt,
)